import { useMemo, useEffect } from 'react';

import { dateFNS } from '@gogame/intl-ts';

export const useNextDayReload = () => {
  const endOfToday = useMemo(() => dateFNS.endOfToday(), []);

  useEffect(
    function checkDay() {
      setTimeout(
        () => {
          const hoursDiff = dateFNS.differenceInHours(Date.now(), endOfToday);
          if (hoursDiff > 2) {
            // more then 2 am
            if (window.navigator.onLine) {
              window.location.reload();
            } else {
              window.addEventListener('online', () => {
                window.location.reload();
              });
            }
          } else {
            checkDay();
          }
        },
        1000 * 60 * 1 /* 1 minutes*/
      );
    },
    [endOfToday]
  );
};
